import type { IntlShape } from 'react-intl'
import { getRequiredFields } from 'util/getZodSchemaRequiredFields'
import { z } from 'zod'

export const VoucherRowSchema = z.object({
	id: z.number(),
	voucher: z.number(),
	account: z.number(),
	accountGroup: z.number(),
	description: z.string(),
	debet: z.string(),
	credit: z.string(),
	costCentreId: z.number(),
	vat: z.number(),
	date: z.string(),
	definition: z.string(),
	state: z.number(),
	modifierName: z.string(),
	databaseSource: z.string(),
})

export const VoucherSchema = z.object({
	id: z.number(),
	createdDate: z.string(),
	creatorId: z.number(),
	creatorName: z.string(),
	databaseSource: z.string(),
	date: z.string(),
	financialYear: z.number(),
	info: z.string(),
	link: z.number(),
	linkType: z.number(),
	name: z.string(),
	number: z.number(),
	state: z.number(),
	type: z.number(),
	voucherRows: z.array(VoucherRowSchema),
})

export const requiredFormFields = getRequiredFields(VoucherSchema)

export type FormInputs = z.infer<typeof VoucherSchema>
export type CreateFormInputs = Omit<
	z.infer<typeof VoucherSchema>,
	'id' | 'createdDate' | 'creatorId' | 'creatorName' | 'databaseSource'
>

// TODO: REMOVE
// eslint-disable-next-line unused-imports/no-unused-vars
export const createFormSchemaLocalized = (intl: IntlShape) => {
	const s = VoucherSchema
	return VoucherSchema.extend({
		id: s.shape.id.optional(),
	})
}

export const basicInformationFormSchema = (intl: IntlShape) =>
	createFormSchemaLocalized(intl).pick({
		id: true,
	})

export const tableFormSchema = (intl: IntlShape) =>
	createFormSchemaLocalized(intl).pick({
		id: true,
	})
